import React, { useEffect } from "react";
import { Navigate, Route, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";

import { useProfile } from "../Components/Hooks/UserHooks";
import { logoutUser } from "../slices/auth/login/thunk";

const AuthProtected = (props) => {
  const dispatch = useDispatch();
  const { userProfile, loading, token } = useProfile();
  const location = useLocation();

  useEffect(() => {
    if (!userProfile && loading && !token) {
      dispatch(logoutUser());
    }
  }, [token, userProfile, loading, dispatch]);

  /*
    Navigate is un-auth access protected routes via url
    */

  if (!userProfile && loading && !token) {
    const redirectUrl = window.location.pathname + window.location.search;
    //console.log("postLoginRedirect", redirectUrl);
    localStorage.setItem("postLoginRedirect", redirectUrl);
    return (
      <Navigate to={{ pathname: "/login", state: { from: props.location } }} />
    );
  }

  // Check if free trial has expired
  if (userProfile && userProfile.user_freeType === "trial" && userProfile.user_billingCycleEnd) {
    const billingCycleEnd = new Date(userProfile.user_billingCycleEnd);
    const now = new Date();
    const isExpired = billingCycleEnd < now;

    // Allow expired trial users to access billing and checkout routes
    const allowedPaths = ["/billing", "/subscribe", "/subscription"];
    const isOnAllowedPath = allowedPaths.some((path) => location.pathname.startsWith(path));

    // Redirect to billing if trial expired and not already on an allowed page
    if (isExpired && !isOnAllowedPath) {
      return <Navigate to="/billing" />;
    }
  }

  return <>{props.children}</>;
};

const AccessRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) => {
        return (
          <>
            {" "}
            <Component {...props} />{" "}
          </>
        );
      }}
    />
  );
};

export { AuthProtected, AccessRoute };
